/**
 * LP specific events.
 */
export enum LiquidityEventName {
  ADD_LIQUIDITY_SUBMITTED = 'Add Liquidity Submitted',
  COLLECT_LIQUIDITY_SUBMITTED = 'Collect Liquidity Submitted',
  MIGRATE_LIQUIDITY_SUBMITTED = 'Migrate Liquidity Submitted',
  REMOVE_LIQUIDITY_SUBMITTED = 'Remove Liquidity Submitted',
  SELECT_LIQUIDITY_POOL_FEE_TIER = 'Select Liquidity Pool Fee Tier',
}
